module.exports = __webpack_public_path__ + "img/Sass_(langage).eac0fdba.png";